import React from "react";
import { UIConfigContext, UpdateUIConfig, UserMessageHandler } from "./UIConfigContext";
import { ActivityDisplay } from "./ActivityDisplay";
import { ActivityBlockConfigData, ChatConfigData } from "../Shared/Party/PartyConfigData";
import { StateManagerContext } from "./StateManagerContext";
import { CreateFanboxMediaList, FanboxMediaList, YouTubePanel } from "./YouTubePanel";
import { YouTubePlayer } from "react-youtube";
import { ContentContextData } from "../Shared/Party/ContentContext";
import { StateManager } from "./PartyState";
import { LandingPage, LandingPageProps } from "./LandingPage";
import { maxHeight } from "@mui/system";
import { ActionHandler, CreateAction, EmptyActionData } from "./ActionButton";


type MainPartyViewState = 'landing' | 'party';

export const MainPartyView = (): JSX.Element => {
    const uiConfig = React.useContext(UIConfigContext);
    const stateManager = React.useContext(StateManagerContext);
    const [viewState, setViewState] = React.useState<MainPartyViewState>('landing');
    const stateListenerId = React.useRef<number>(-1);
    const [ytPlaylist, _setYTPlaylist] = React.useState<FanboxMediaList>(CreateFanboxMediaList(stateManager.context().media));
    const youTubePlayer = React.useRef<YouTubePlayer | null>(null);
    const [videoPaused, setVideoPaused] = React.useState(true);
    const optionalActivity = React.useRef<ActivityBlockConfigData | null>(null);
    const optionalTransition = React.useRef<number>(-1);
    const mainTransition = React.useRef<boolean>(false);
    const mainActivity = React.useRef<ActivityBlockConfigData>((()=>{
        const mn = stateManager.main().main;
        UpdateUIConfig(uiConfig, mn);
        return mn;
    })());
    const [showEnterButton, setShowEnterButton] = React.useState<boolean>(false);
    const mainUserMessageHandler = React.useRef<UserMessageHandler | null>(null);
    const optionalUserMessageHandler = React.useRef<UserMessageHandler | null>(null);
    const rcRef = React.useRef<number>(0);
    const [rc, setRC] = React.useState<number>(0);



    const closeOptional = (isTimeout: boolean = false) => {

        rcRef.current++;
        setRC(rcRef.current);
        const divName = uiConfig.optionalDirection === 'bottom' ? 'partyOptionalDisplayBottom' : 'partyOptionalDisplayTop';
        const vert = uiConfig.optionalDirection === 'bottom' ? uiConfig.height : -uiConfig.height;
        const optionalDiv = document.getElementById(divName);
        if (optionalDiv !== null) {
            optionalDiv.style.top = vert + 'px';
        }
        if (isTimeout) {
            if (optionalTransition.current >= 0) {
                window.clearTimeout(optionalTransition.current);
                optionalTransition.current = -1;
            }
        }
        window.setTimeout(() => {
            optionalActivity.current = null;
        }, 1000)
    }

    const showOptional = (itemId: string) => {
        const optional = stateManager.context().optional[itemId];
        if (optional !== undefined) {
            const time = Date.now();
            if (time >= optional.startTime && time <= (optional.endTime - 3000)) {
                optionalActivity.current = optional;
                rcRef.current++;
                setRC(rcRef.current);
                const divName = uiConfig.optionalDirection === 'bottom' ? 'partyOptionalDisplayBottom' : 'partyOptionalDisplayTop';
                const optionalDiv = document.getElementById(divName);
                if (optionalDiv !== null) {
                    optionalDiv.style.top = uiConfig.optionalDirection === 'top' ? 0 + 'px' : uiConfig.optionalLimit + 'px';
                }
            }

            const delta = optional.endTime - time;
            optionalTransition.current = window.setTimeout(() => {
                closeOptional(true);
            }, delta)
        }
    }

    const onYTReady = (player: YouTubePlayer) => {
        youTubePlayer.current = player;
        setShowEnterButton(true);
    }

    const setUserMessageHandler = (handler: UserMessageHandler) => {
        if (optionalActivity.current === null)
            mainUserMessageHandler.current = handler;
        else
            optionalUserMessageHandler.current = handler;
    }

    uiConfig.setUserMessageHandler = setUserMessageHandler;


    const getUserMessageHandler = (): UserMessageHandler | null => {
        if (mainUserMessageHandler.current !== null && optionalActivity.current === null)
            return mainUserMessageHandler.current;
        else if (optionalUserMessageHandler.current !== null && optionalActivity.current !== null)
            return optionalUserMessageHandler.current;
        else
            return mainUserMessageHandler.current;
    }

    uiConfig.getUserMessageHandler = getUserMessageHandler;



    const onEnterParty : ActionHandler = (_action) => {
        if (youTubePlayer.current !== null) {
            setViewState('party');
            youTubePlayer.current.playVideo();
            stateManager.activateTriggers();
        }
        return true;
    }
    const onEnterAction = CreateAction('enterParty', [], onEnterParty);

    const stateUpdateDisplay = (state: StateManager) => {
        const mainDiv = document.getElementById('partyMainDisplay');
        if ((mainDiv !== null) && (!mainTransition.current)) {
            mainDiv.style.opacity = '0.0';
            mainTransition.current = true;
            window.setTimeout(() => {
                const time = Date.now();
                //if (state.main().startTime <= time) {
                mainActivity.current = state.main().main;
                UpdateUIConfig(uiConfig, mainActivity.current);
                console.log('Loading stateManager main with next =>' + mainActivity.current.activityType + (mainActivity.current.activityType === 'chat' ? (mainActivity.current.config as ChatConfigData).itemId : ''));
                mainDiv.style.opacity = '1.0';
                mainTransition.current = false;
                rcRef.current = rcRef.current + 1;
                setRC(rcRef.current);

                //}
            }, 1000);
        }


    }

    const stateUpdateMedia = (nextContext: ContentContextData) => {
        ytPlaylist.addItems(nextContext.media);
    }

    const timeHandler = (state: StateManager, time: number) => {

    }


    if (stateListenerId.current === -1) {

        const slid = Math.random();
        stateManager.addTickListener(slid, timeHandler);
        stateListenerId.current = slid;
        stateManager.addNotifyMainUpdateFunction(Math.random(), stateUpdateDisplay);
        stateManager.addNotifyNextContextUpdateFunction(Math.random(), stateUpdateMedia);
        stateManager.setTriggerHandler(showOptional);
        uiConfig.showOptional = showOptional;
    }

    const pauseHandler = (onPause: boolean) => {
        //console.log("onPause: " + onPause + "  videoPaused: " + videoPaused);
        if (onPause !== videoPaused) {
            setVideoPaused(onPause);
            //console.log("set video paused to " + videoPaused);
        }
    }



    var mainActivityDisplay: JSX.Element = <ActivityDisplay activity={mainActivity.current} main={true} key={'MainActivity_' + mainActivity.current.config.itemId}/>
    var optionalActvitiyDisplay: JSX.Element = optionalActivity.current === null ? <div></div> : <ActivityDisplay activity={optionalActivity.current} main={false} key={'OPtionalActivity_' + optionalActivity.current.config.itemId} />

    const landingProps: LandingPageProps = {
        height: uiConfig.height - uiConfig.titleHeight,
        action : onEnterAction,
        actionData : EmptyActionData,
        showEnterButton: showEnterButton,
        image: stateManager.context().image, //s3URL + "taylor-headline.png",
        heading: stateManager.context().title,//"Taylor Swift",
        subHeading: 'Listening Party', //"ERAS Tour",
        description: stateManager.context().description, //"Join 187,000 fans from around the world as they share their experiences of being part of the biggest tour in the history of music",
        buttonText: "Enter Party",
        noEntryText : '...initializing'
    }

    const time = Date.now();
    const showMain = mainActivity.current.startTime <= time;
    var mainTop = uiConfig.mainSpan[0];



    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "black",
                position: "relative",
                minHeight : uiConfig.height - uiConfig.titleHeight,
                maxHeight : uiConfig.height - uiConfig.titleHeight,
                minWidth : uiConfig.width,
                maxWidth : uiConfig.width,
                overflow : 'clip'

            }}
        > <div style = {{ 
            minHeight : uiConfig.height - uiConfig.titleHeight,
            maxHeight : uiConfig.height - uiConfig.titleHeight,
            minWidth : uiConfig.width,
            maxWidth : uiConfig.width,
            overflow : 'auto',
            
        }}> <div style = {{
            minHeight : uiConfig.mainPanelHeight,
            maxHeight : uiConfig.mainPanelHeight,
            minWidth : uiConfig.width,
            maxWidth : uiConfig.width,
            position : 'relative',
            overflow : 'clip',
            backgroundColor : uiConfig.contolBackground

        }}>
            <div
                style={{
                    backgroundColor: "black",
                    borderTop: "2px solid white",
                    position: 'absolute',
                    top: uiConfig.videoSpan[0] + 'px',
                    width: uiConfig.width + 'px'
                }}
            >
                <YouTubePanel playlist={ytPlaylist} availableHeight={uiConfig.videoHeight} availableWidth={uiConfig.videoWidth} readyHandler={onYTReady} />
            </div>


            <div id='partyMainDisplay' style={{ transition: 'opacity 1s', transitionTimingFunction: 'ease-in-out', position: 'absolute', top: mainTop + 'px' }}>
                {showMain && mainActivityDisplay}
            </div>
            </div></div>

            <div id='partyOptionalDisplayTop' style={{ opacity: 1.0, transition: 'top 1s', transitionTimingFunction: 'ease-in-out', position: 'absolute', top: (-uiConfig.height) + 'px' }}>
                {(optionalActivity.current !== null && !(mainActivity.current.mediaPosition === 'top' || mainActivity.current.mediaPosition === 'all')) &&
                    <div style={{ display: 'flex', flexDirection: 'column', position: 'static' }}>
                        {optionalActvitiyDisplay}
                    </div>}
                <div style={{ backgroundColor: '#92007f', minHeight: '30px', maxHeight: '30px', display: 'flex', justifyContent: 'right' }} onClick={() => { closeOptional(); }}> <img src='/images/white-close-tranparent30.png' /></div>
            </div>

            <div id='partyOptionalDisplayBottom' style={{ opacity: 1.0, transition: 'top 1s', transitionTimingFunction: 'ease-in-out', position: 'absolute', top: uiConfig.height + 'px' }}>
                {(optionalActivity.current !== null && (mainActivity.current.mediaPosition === 'top' || mainActivity.current.mediaPosition === 'all')) &&
                    <div style={{ display: 'flex', flexDirection: 'column', position: 'static' }}>
                        <div style={{ backgroundColor: '#92007f', minHeight: '30px', maxHeight: '30px', display: 'flex', justifyContent: 'right' }} onClick={() => { closeOptional(); }}><img src='/images/white-close-tranparent30.png' /></div>
                        {optionalActvitiyDisplay}
                    </div>}
            </div>


            {viewState === 'landing' && <div style={{ position: 'absolute' }}>
                <LandingPage {...landingProps} />
            </div>}
        </div>

    );













}